import axios from 'axios';
import { api_labelflow, api_labelflow_training } from "../../../../../config.jsx";

export const handleGetOneAPI = (params) =>
  axios.get(`${api_labelflow}/segmentation_management/get_one_segmentation_model_info_by_version_id`, {
    params: params
  });

export const handleDownloadSegmentationDataAPI = async (params) => {
  try {
    const response = await axios.post(
      `${api_labelflow_training}/export_management/segmentation_data_download`,
      new URLSearchParams(params),
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error downloading segmentation data:', error);
    throw error;
  }
};

export const startSegmentationTrainingAPI = async (data) => {
  try {
    const response = await axios.post(
      `${api_labelflow_training}/training_management/segmentation/start`,
      new URLSearchParams(data),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error starting segmentation training:', error);
    throw error;
  }
};

export const saveSegmentationTrainingConfigAPI = async (data) => {
  try {
    const response = await axios.post(
      `${api_labelflow_training}/training_management/save_training_config`,
      new URLSearchParams(data),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error saving segmentation training config:', error);
    throw error;
  }
};
